import { ISelectOption } from 'components/forms/Selects'

/**
 * Used to generate an array of options for <Select />
 * @example const getCarrierOptions = (motorCarriers: IMotorCarrier[]) => getSelectOptions({ options: motorCarriers, mapOption: ({ dotNumber: value, legalName: label }) => ({ value, label })})
 */
export const getSelectOptions = <T extends Object>({
  mapOption,
  options,
}: {
  options: T[]
  mapOption: (data: T) => ISelectOption
}): ISelectOption[] => {
  return options.map(mapOption)
}
